import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickMakeNewFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_MAKE_NEW_FOLDER' });
  }, [logAnalyticsEvent]);
};
